export function pxToMM(px: number): number {
  return px / 3.7795275591;
}
